const currentLocationDefaultState = {
    info: {},
    loading: true,
    error: false,
};

export default (state = currentLocationDefaultState, action) => {

    switch(action.type) {

        case 'LOAD_LOCATION_INFO':
            return {
                ...state,
                info: action.location,
                loading: false
            }

        case 'LOCATION_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error
            }

        case 'CURRENT_LOCATION_LOADING':
            return {
                ...state,
                loading: true
            }

        default:
            return state;
    }
};